import Styled from './toolbar.module.css'
import { FiEye, FiEdit } from 'react-icons/fi'
import { useContext } from 'react'
import { LandingContext } from '../../Context'
import { ToolBarProps } from '../../Context/types'
import { Button } from '../../Components/Global'

function ToolBar({ valueState }: ToolBarProps) {
    const { handleFormatText, setWebsiteSettings, websiteSettings } = useContext(LandingContext)
    return (
        <div className={Styled.container_toolbar}>

            <Button type="button" className={Styled.btn_toggleView} onClick={() => {
                setWebsiteSettings({
                    ...websiteSettings, [valueState.ref]: {
                        ref: valueState.ref,
                        value: valueState.value,
                        ToggleView: !valueState.ToggleView
                    }
                })
            }}>

                {valueState.ToggleView ? (
                    <>
                        <FiEdit />
                        Editar
                    </>
                ) : (
                    <>
                        <FiEye />
                        Visualizar
                    </>
                )}
            </Button>
            <div className={Styled.container_btn_formation}>

                <button type="button" className={valueState.ToggleView ? `${Styled.disabled}` : `${Styled.btn_format}`} onClick={() => handleFormatText({
                    tag: 'i',
                    valueState
                })}>
                    <i>I</i>
                </button>
                <button type="button" className={valueState.ToggleView ? `${Styled.disabled}` : `${Styled.btn_format}`} onClick={() => handleFormatText({
                    tag: 'strong',
                    valueState
                })}>
                    <strong>N</strong>
                </button>
                <button type="button" className={valueState.ToggleView ? `${Styled.disabled}` : `${Styled.btn_format}`} onClick={() => handleFormatText({
                    tag: 'mark',
                    valueState
                })}>
                    <mark>M</mark>
                </button>
                <button type="button" className={valueState.ToggleView ? `${Styled.disabled}` : `${Styled.btn_format}`} onClick={() => handleFormatText({
                    tag: 's',
                    valueState,
                })}>
                    <s>S</s>
                </button>
                <button type="button" className={valueState.ToggleView ? `${Styled.disabled}` : `${Styled.btn_format}`} onClick={() => handleFormatText({
                    tag: 'small',
                    valueState,
                })}>
                    <small>s</small>
                </button>
                <button type="button" className={valueState.ToggleView ? `${Styled.disabled}` : `${Styled.btn_format}`} onClick={() => handleFormatText({
                    tag: 'em',
                    valueState,
                })}>
                    <em>e</em>
                </button>
            </div>
        </div>
    )
}

export default ToolBar